module.exports = __webpack_public_path__ + "img/17.e465e860.jpg";